module.exports = __webpack_public_path__ + "img/recommendations.fe9d5128.svg";